import React, { useState } from "react";
import { Table, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import "./index.css";

const ReservationViewTable = ({
  setSelectedTimeForReservation,
  setClickedTableForReservation,
  showOrHideColumns,
}) => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const { tablesWithReservations, reservations } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const data = [];
  tablesWithReservations.forEach((table, index) => {
    data.push({
      key: index,
      tableName: {
        name: table.tableName,
        seats: table.seatsCount,
        touchSaleTableId: table.touchSaleTableId,
      },
      touchSaleTableId: table.touchSaleTableId,
    });
    table.reservations.forEach((reservation) => {
      data[index][reservation.reservationTime.slice(0, 5)] = reservation;
    });
  });

  const columns = [
    {
      title: <span style={{ textAlign: "center" }}>Маса</span>,
      dataIndex: "tableName",
      key: "tableName",
      align: "center",
      fixed: "left",
      width: "200px",
      render: (value) => (
        <div
          onClick={() => {
            dispatch({
              type: "OPEN_RESERVATION_CREATE_MODAL",
            });
            setClickedTableForReservation(value.touchSaleTableId);
          }}
          style={{ cursor: "pointer" }}
        >
          <strong>№ {value.name}</strong> | {value.seats} места
        </div>
      ),
    },
  ];

  const times = [
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
  ];

  if (showOrHideColumns) {
    times.splice(
      0,
      (parseInt(dayjs().subtract(1, "hour").format("HH")) - 11) * 2
    );
  }

  times.forEach((item) => {
    // Calculate the number of tables with reservations for this time slot and total seats
    let reservedTablesCount = 0;
    let totalSeats = 0;

    data.forEach((table) => {
      if (table[item]) {
        reservedTablesCount++;

        const seated = reservations.filter(
          (reservation) =>
            reservation.reservationId === table[item].reservationId
        )[0]?.guestsCount;
        totalSeats += seated;
      }
    });

    columns.push({
      title: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {item.slice(3, 5) === "00" ? (
            item.slice(0, 2)
          ) : (
            <span style={{ fontWeight: "normal" }}>{item}</span>
          )}
          <span style={{ opacity: "0.5" }}>
            {reservedTablesCount !== 0
              ? `${reservedTablesCount} | ${totalSeats}`
              : "-"}
          </span>
        </div>
      ),
      dataIndex: item,
      key: item,
      width: "70px",
      align: "center",
      onHeaderCell: () => ({
        // Click on HeaderCell
        style: {
          cursor: "pointer",
          textAlign: "center",
          padding: "0px",
        },
        onClick: () => {
          dispatch({
            type: "OPEN_RESERVATION_CREATE_MODAL",
          });
          setSelectedTimeForReservation(item);
        },
      }),
      render: (value) => (
        <div
          style={{
            whiteSpace: "normal", // Allow text to wrap
            overflow: "hidden", // Hide the overflow
            display: "-webkit-box", // Display as a box
            WebkitLineClamp: 3, // Limit the number of lines (2 lines in this case)
            WebkitBoxOrient: "vertical", // Orient box vertically
            fontSize: "12px",
          }}
        >
          {`${value?.name || ""}${value?.note ? " / " : ""}${
            value?.note || ""
          }${value?.deposit > 0 ? ` | Деп: ${value.deposit.toFixed(2)}` : ""}`}
        </div>
      ),
      onCell: (record) => ({
        style: {
          backgroundColor: record[item] !== undefined ? "#fbe4d5" : "#e2efd9",
          padding: "0px",
          width: "70px",
          cursor: "pointer",
        },
        colSpan:
          record[item] === undefined
            ? 1
            : record[item].hide === true
            ? 0
            : record[item].duration * 2,
        onClick: () => {
          if (record[item] !== undefined) {
            dispatch({
              type: "OPEN_RESERVATION_EDIT_MODAL",
              reservation: reservations.filter(
                (reservation) =>
                  reservation.reservationId === record[item].reservationId
              )[0],
            });
          } else {
            dispatch({
              type: "OPEN_RESERVATION_CREATE_MODAL",
            });
            setSelectedTimeForReservation(item);
            setClickedTableForReservation(record.touchSaleTableId);
          }
        },
      }),
    });
  });

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter((row) => {
    if (searchQuery === "") {
      return true;
    }
    let hasMatch = false;

    times.forEach((time) => {
      if (row[time]) {
        if (row[time].name.toLowerCase().includes(searchQuery.toLowerCase())) {
          hasMatch = true;
        }
        if (
          row[time].note !== "" &&
          row[time].note.toLowerCase().includes(searchQuery.toLowerCase())
        ) {
          hasMatch = true;
        }
      }
    });

    return hasMatch;
  });

  return (
    <>
      <Input
        className="reservation-view-input"
        placeholder="Търсене..."
        prefix={<SearchOutlined />}
        value={searchQuery}
        onChange={handleSearchChange}
      />
      <Table
        dataSource={filteredData}
        pagination={false}
        bordered
        scroll={{ x: "max-content" }}
        columns={columns}
        className="reservation-view-table"
        loading={data.length === 0}
        sticky
      />
    </>
  );
};
export default ReservationViewTable;
